import script from "./CollectionCardCounts.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionCardCounts.vue?vue&type=script&setup=true&lang=js"

import "./CollectionCardCounts.vue?vue&type=style&index=0&id=05ead1f6&lang=scss"

const __exports__ = script;

export default __exports__